import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createTracker } from 'redux-segment';

import rootReducer from './reducers';
import rootSaga from './sagas';
import history from '../history';

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
const sagaMiddleware = createSagaMiddleware();
const tracker = createTracker();

const index = createStore(
  rootReducer(history),
  composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware, tracker)),
);

sagaMiddleware.run(rootSaga);

export default index;
